import React from "react";
import "../adminDesktop.css";

/** Compact reorder controls used in catalog tables (desktop). */
export function AdmMoveButtons({ name, onUp, onDown, disableUp = false, disableDown = false }) {
  return (
    <span className="adm-order">
      <button
        type="button"
        className="kpi-back-btn adm-icon"
        aria-label={`Move ${name} up`}
        disabled={disableUp}
        onClick={onUp}
      >
        ↑
      </button>
      <button
        type="button"
        className="kpi-back-btn adm-icon"
        aria-label={`Move ${name} down`}
        disabled={disableDown}
        onClick={onDown}
      >
        ↓
      </button>
    </span>
  );
}

/** Settings row: title + help on the left, toggle switch on the right. */
export function AdmSwitchRow({ title, help, checked, disabled, onChange }) {
  return (
    <label className="adm-setting">
      <span className="adm-setting__text">
        <span className="adm-setting__title">{title}</span>
        {help ? <span className="adm-setting__help">{help}</span> : null}
      </span>
      <span className="adm-switch">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-label={title}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span aria-hidden="true" />
      </span>
    </label>
  );
}
